import createLeaderboardFilterProvider from '#/leaderboard/contexts/filter-provider-factory';

const [
  LiquidityFilterProvider,
  useLiquidityFilterState,
  useLiquidityFilterActions,
] = createLeaderboardFilterProvider({ key: 'liquidity-filter' });

export { useLiquidityFilterState, useLiquidityFilterActions };
export default LiquidityFilterProvider;
